<script lang="ts">
	import type { PageProps } from "./$types";
	import { BlogSection } from "#lib/web-ui/blocks/blog/index.js";

	let { data }: PageProps = $props();
</script>

<svelte:head>
	<title>Real Estate Investment Blog | Fergmar Capital</title>
	<meta
		name="description"
		content="In-depth analysis on real estate market trends, investment strategies, and lessons from Fergmar Capital's portfolio operations. New articles monthly."
	/>
	<meta property="og:title" content="Real Estate Investment Blog | Fergmar Capital" />
	<meta
		property="og:description"
		content="Market trends, syndication investment strategies, and portfolio operations insights from Fergmar Capital."
	/>
	<meta name="twitter:title" content="Real Estate Investment Blog | Fergmar Capital" />
	<meta
		name="twitter:description"
		content="Market trends, syndication investment strategies, and portfolio operations insights from Fergmar Capital."
	/>

	{@html `<script type="application/ld+json">${JSON.stringify({
		"@context": "https://schema.org",
		"@type": "Blog",
		name: "Fergmar Capital Insights",
		description:
			"Market trends, syndication investment strategies, and portfolio operations insights from Fergmar Capital.",
		url: "https://fergmarcapital.com/media/blog",
		publisher: {
			"@type": "Organization",
			name: "Fergmar Capital",
			url: "https://fergmarcapital.com"
		},
		blogPost: data.blogPosts.slice(0, 10).map((post) => ({
			"@type": "BlogPosting",
			headline: post.title,
			description: post.excerpt,
			datePublished: post.publishedAt,
			...(post.featureImage && { image: post.featureImage }),
			author: { "@type": "Person", name: post.author }
		}))
	})}</script>`}
</svelte:head>

<h1 class="sr-only">Real Estate Investment Tips and Analysis from Fergmar Capital</h1>

<BlogSection
	label="Market Intelligence"
	title="Market Insights & Analysis"
	subtitle="In-depth analysis on market trends, investment strategies, and lessons from our portfolio operations."
	posts={data.blogPosts}
	blogBaseUrl="/media/blog"
	theme="light"
/>
